function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useContext } from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { useAccentColors } from '../../hooks';
import ReactConfigContext from '../../ReactConfigContext';
export default function ProfileImage(param) {
    var image = param.image, _param_color = param.color, color = _param_color === void 0 ? '--colors-blue-500' : _param_color, _param_accent = param.accent, accent = _param_accent === void 0 ? 'always' : _param_accent, className = param.className;
    var _image_sizes;
    var _useContext = useContext(ReactConfigContext), ImageComponent = _useContext.config.ImageComponent;
    var accentStyle = useAccentColors([
        'colors-profile-image-accent',
        color
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        style: accentStyle,
        className: twMerge('grid grid-cols-1 grid-rows-1 items-center', className)
    }, /*#__PURE__*/ React.createElement("svg", {
        width: "185",
        height: "205",
        viewBox: "0 0 185 205",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: twMerge('col-start-1 row-start-1 w-full h-auto', accent === 'desktop-only' && 'hidden md:block')
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M102.333 0.5C46.089 0.5 0.333252 46.2737 0.333252 102.512C0.333252 158.749 46.089 204.488 102.333 204.5V150.533C75.8511 150.533 54.306 129.002 54.306 102.523C54.306 76.044 75.8511 54.4898 102.333 54.4782V0.511591V0.5Z",
        fill: "var(--colors-profile-image-accent)"
    })), /*#__PURE__*/ React.createElement("div", {
        className: twMerge('ml-auto w-[84%] col-start-1 row-start-1', accent === 'desktop-only' && 'w-full md:w-[84%]')
    }, /*#__PURE__*/ React.createElement("div", {
        className: "aspect-w-1 aspect-h-1"
    }, /*#__PURE__*/ React.createElement(ImageComponent, _object_spread_props(_object_spread({}, image), {
        sizes: (_image_sizes = image.sizes) !== null && _image_sizes !== void 0 ? _image_sizes : '300px',
        className: "object-cover object-center rounded-full w-full h-full"
    })))));
}

//# sourceMappingURL=ProfileImage.js.map